// Loader.js
import React, { useEffect } from "react";
import mainLogo from "../../assets/images/mainLogo.png";
import "./LoaderSquares.css";

const Loader = ({ debugMode = false, customText = null }) => {
  // Signal that React Loader is mounted and visible
  useEffect(() => {
    // Wait for fadeIn animation to complete (0.5s) before hiding initial loader
    // This ensures smooth transition without white flash
    const timer = setTimeout(() => {
      if (window.hideInitialLoader) {
        window.hideInitialLoader();
      }
    }, 600); // Slightly longer than animation (500ms) to ensure it's visible

    return () => clearTimeout(timer);
  }, []);

  return (
    <div 
      className={`loader-root ${debugMode ? 'loader-debug-mode' : ''}`}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#fefbef',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
        overflow: 'hidden'
      }}>


      {/* Top-Left Area */}
      <div className="loader-square-yellow-top-left"></div>
      <div className="loader-square-green-left"></div>
      <div className="loader-square-blue-top-left"></div>
      <div className="loader-square-red-outline-left"></div>

      {/* Top-Right Area */}
      <div className="loader-square-yellow-top-right"></div>
      <div className="loader-square-red-top-right"></div>
      <div className="loader-square-red-outline-top-right"></div>
      <div className="loader-square-green-outline-top-right"></div>

      {/* Bottom-Left Area */}
      <div className="loader-square-blue-bottom-left"></div>
      <div className="loader-square-red-bottom-left"></div>
      <div className="loader-square-red-outline-bottom-left"></div>
      <div className="loader-square-green-outline-bottom-left"></div>
      <div className="loader-square-yellow-outline-bottom-left"></div>

      {/* Bottom-Right Area */}
      <div className="loader-square-green-bottom-right"></div>
      <div className="loader-square-yellow-outline-bottom-right"></div>
      <div className="loader-square-blue-outline-bottom-right"></div>
      <div className="loader-square-red-outline-bottom-right"></div>

      {/* Centrale content */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        zIndex: 10,
        opacity: 0,
        animation: 'fadeIn 0.5s ease-in forwards',
        transform: "translateY(-80px)", 

      }}>
        {customText ? (
          <div style={{
            fontFamily: 'Union, sans-serif',
            fontSize: '1.6rem',
            color: 'black',
            fontWeight: 'normal',
            textAlign: 'center',
            marginBottom: '10px'
          }}>
            {customText}
          </div>
        ) : (
          <>
            {/* Logo */}
            <img 
              src={mainLogo} 
              alt="WordHit Logo"
              style={{
                width: '220px',
                height: 'auto',
                maxWidth: '80vw'
              }}
            />

            {/* "by SmartFriends" label */}
            <div style={{
              fontFamily: 'Union, sans-serif',
              fontSize: '1.4rem',
              color: 'black',
              fontWeight: 'normal',
              textAlign: 'center'
            }}>
              by SmartFriends
            </div>
          </>
        )}

        {/* Activity loading indicator - circular spinner */}
        <div style={{
          width: '20px',
          height: '20px',
          border: '4px solid rgba(25, 64, 147, 0.2)',
          borderTop: '4px solid black',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
      </div>

      <style>
        {`
          @keyframes fadeIn {
            0% {
              opacity: 0;
            }
            100% {
              opacity: 1;
            }
          }

          @keyframes fadeOut {
            0% {
              opacity: 1;
            }
            100% {
              opacity: 0;
            }
          }

          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </div>
  );
};

export default Loader;
